import {
  Box,
  Flex,
  Select,
  Text,
  Card,
  CardBody,
  CardHeader,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import React, { useRef } from "react";
import Issue from "./Issue";
import Fine_Modal_Library from "./Fine/Fine_Modal_Library";
import Create_Member from "../../Membership/CreateMember/Create_Member";

const Issue_main = () => {
  const printComponentRef = useRef();

  return (
    <Box maxWidth="100%" >
      <div className="teacher-list-container">
        <div
          className="header"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h1 style={{ fontSize: "20px", margin: 0 }}>Issue Book</h1>
          <div className="action-buttons" style={{ marginLeft: "auto" }}>
            <div className="export-dropdown">
              <Flex gap={2}>
                {/* Add action buttons here */}

                <Fine_Modal_Library />
                {/* <Create_Member /> */}
              </Flex>
            </div>
          </div>
        </div>

        <Box className="breadcrumb" mb={4}>
          <Link
            to="/admin"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Dashboard</span>
          </Link>{" "}
          / <span>Library </span> /
          <Link
            to="/class/classlist"
            style={{ textDecoration: "none", color: "inherit" }}
          >
            <span>Issue Book</span>
          </Link>
        </Box>
      </div>
      <Box p={5}>
      <Issue />
      </Box>
    </Box>
  );
};

export default Issue_main;
